import React from "react";
import { NotificationPayloadData } from "types/notification.api";
import { timeFromNow } from "utils/utils";

interface NotificationProp {
  notifications: NotificationPayloadData[];
  onViewAllClick: () => void;
}

const Notifications: React.FC<NotificationProp> = ({
  notifications,
  onViewAllClick,
}) => {
  return (
    <div className="bg-white shadow-sm pt-3 br-10 d-flex flex-column notifications-wrapper">
      <div className="d-flex justify-content-between align-items-center mb-3  pe-3 ps-3">
        <p className="font-primary fw-medium fs-16 text-black2D mb-0">
          Notifications
        </p>

        <button
          className="btn  p-0 font-primary fw-normal fs-12 text-primary"
          onClick={onViewAllClick}
        >
          View All &gt;
        </button>
      </div>

      <div className="divider mb-3" />

      <div className="overflow-auto flex-grow-1 d-flex flex-column gap-2 pe-3 ps-3 notifications-scroll mb-2">
        {(notifications || []).map((item, index) => (
          <div
            key={index}
            className="d-flex justify-content-between align-items-start "
          >
            <p className="text-black2D font-primary fw-normal fs-16 me-3">
              {item.message}
            </p>
            <p className="text-grey89 font-primary fw-normal fs-12 ps-1 d-flex d-inline-flex text-nowrap">
              {timeFromNow(item.created_at)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(Notifications);
